export default function isFunction(prop) {
  return !!(prop && typeof prop === 'function')
}
